export const TYPES = {
  POLYLINE: 'POLYLINE',
  POLYGON: 'POLYGON',
  MARKER: 'MARKER',
}
